import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import Link from '@nerdwallet/react-link';
import LoadingSpinner from '@nerdwallet/react-loading-spinner';
import BackButton from './compare-back-button';
import CompareLink from './compare-link';
import CompareCardImages from './compare-card-images';
import CompareAddButton from './compare-add-button';
import './compare-cta.less';

var CompareCTA = /*#__PURE__*/function (_React$Component) {
  _inherits(CompareCTA, _React$Component);

  var _super = _createSuper(CompareCTA);

  function CompareCTA() {
    _classCallCheck(this, CompareCTA);

    return _super.apply(this, arguments);
  }

  _createClass(CompareCTA, [{
    key: "render",
    value: function render() {
      var _this$props$mobileCta,
          _this = this;

      // We do some flex-order reversing based on the value of this.props.showCardImages. This can
      // make the LoadingSpinner appear at the wrong end of the bar. For this reason, there's two
      // instances of the LoadingSpinner in the markup below (although only one is rendered at one
      // time).
      return /*#__PURE__*/React.createElement("div", {
        className: "compare-cta"
      }, this.props.showCardImages && this.props.isCompareCardsBusy ? /*#__PURE__*/React.createElement("div", {
        className: "compare-cta__spinner-container"
      }, /*#__PURE__*/React.createElement(LoadingSpinner, {
        color: "green",
        size: 30
      })) : null, this.props.showCardImages ? /*#__PURE__*/React.createElement(CompareCardImages, {
        removeFromCompare: this.props.removeFromCompare,
        cardsToCompare: this.props.cardsToCompare,
        cardIDsToCompare: this.props.cardIDsToCompare
      }) : null, this.props.showAddCard ? /*#__PURE__*/React.createElement(CompareAddButton, {
        saveToCompare: this.props.saveToCompare,
        cardsToCompare: this.props.cardsToCompare,
        analytics: this.props.analytics,
        offerSDK: this.props.offerSDK
      }) : null, !this.props.showBackButton || this.props.overrideCTA ? /*#__PURE__*/React.createElement(CompareLink, {
        isActive: this.props.numCardsToCompare && this.props.numCardsToCompare > 0,
        numCardsToCompare: this.props.numCardsToCompare,
        buttonClassName: this.props.buttonClassName,
        isLinkToSameApp: this.props.isLinkToSameApp,
        overrideCTA: this.props.overrideCTA,
        ctaText: this.props.ctaText.cta,
        mobileCtaText: (_this$props$mobileCta = this.props.mobileCtaText) === null || _this$props$mobileCta === void 0 ? void 0 : _this$props$mobileCta.cta,
        taxonomy: this.props.taxonomy
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "back-reset"
      }, this.props.showBackButton ? /*#__PURE__*/React.createElement(BackButton, {
        history: this.props.history
      }) : this.props.numCardsToCompare ? this.props.disableReset ? /*#__PURE__*/React.createElement(Link, {
        color: "neutral-lighter",
        className: "reset-link reset-link--no-link"
      }, this.props.ctaText.reset) : /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Link, {
          color: "neutral-darker",
          className: "reset-link",
          onClick: function onClick() {
            return _this.props.clearCompareList(_this.props.analytics.enabled, value === null || value === void 0 ? void 0 : value.impressionId);
          }
        }, _this.props.ctaText.reset);
      }) : null), !this.props.showCardImages && this.props.isCompareCardsBusy ? /*#__PURE__*/React.createElement("div", {
        className: "compare-cta__spinner-container"
      }, /*#__PURE__*/React.createElement(LoadingSpinner, {
        color: "green",
        size: 30
      })) : null);
    }
  }]);

  return CompareCTA;
}(React.Component);

_defineProperty(CompareCTA, "propTypes", {
  // eslint-disable-next-line react/require-default-props
  buttonClassName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
  clearCompareList: PropTypes.func.isRequired,
  ctaText: PropTypes.shape({
    cta: PropTypes.string,
    reset: PropTypes.string
  }),
  mobileCtaText: PropTypes.shape({
    cta: PropTypes.string
  }),
  disableReset: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  // eslint-disable-next-line react/require-default-props
  history: PropTypes.shape({
    goBack: PropTypes.func
  }),
  // eslint-disable-next-line react/require-default-props
  isCompareCardsBusy: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  isLinkToSameApp: PropTypes.bool,
  numCardsToCompare: PropTypes.number,
  offerSDK: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/require-default-props
  overrideCTA: PropTypes.node,
  removeFromCompare: PropTypes.func.isRequired,
  saveToCompare: PropTypes.func.isRequired,
  showAddCard: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  showBackButton: PropTypes.bool,
  showCardImages: PropTypes.bool,
  taxonomy: PropTypes.shape({})
});

_defineProperty(CompareCTA, "defaultProps", {
  analytics: {
    enabled: false
  },
  cardsToCompare: {},
  cardIDsToCompare: [],
  ctaText: {
    cta: 'Compare Cards',
    reset: 'Reset'
  },
  mobileCtaText: null,
  disableReset: false,
  numCardsToCompare: 0,
  showAddCard: false,
  showCardImages: false,
  taxonomy: {}
});

export { CompareCTA as default };